import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  banner: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2, 4),
    padding: theme.spacing(2, 4),
    background: theme.colorPalette.orange_50_op_08,
    borderBottom: `1px solid ${theme.colorPalette.orange_50}`,
    color: theme.colorPalette.green_100,
    fontSize: 14
  },
  icon: {
    flex: 'none',
    color: theme.colorPalette.orange_50
  },
  message: {
    flex: '1 1 320px'
  }
}));
